// Strip showing the parties to a matter. Names from `template.ui.parties`
// (e.g. ["Plaintiff","Defendant","Carrier","Lienholders"]). For each
// party we render a small chip; the chip surfaces the matched value
// from `matter.workspace.parties[<role>]` if present.

import type { WidgetProps } from "./types";
import { WidgetCard } from "./WidgetCard";

export function PartiesStripWidget({ matter, template }: WidgetProps) {
  const parties = (template?.ui?.parties as string[] | undefined) ?? [];
  const partyData = (matter.workspace?.parties as Record<string, unknown> | undefined) ?? {};

  if (parties.length === 0) {
    return (
      <WidgetCard title="Parties">
        <div style={{ fontSize: 12.5, color: "var(--muted)" }}>
          Parties not configured for this practice area.
        </div>
      </WidgetCard>
    );
  }

  return (
    <WidgetCard title="Parties" sub={`${parties.length}`}>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "max-content 1fr",
          gap: "6px 12px",
          fontSize: 12,
        }}
      >
        {parties.map((p) => {
          const v = partyData[p] ?? partyData[p.toLowerCase()];
          const display =
            v == null ? "—" : typeof v === "string" || typeof v === "number" ? String(v) : "set";
          return (
            <div key={p} style={{ display: "contents" }}>
              <span
                style={{
                  fontSize: 9.5,
                  fontWeight: 700,
                  textTransform: "uppercase",
                  letterSpacing: "0.08em",
                  color: "var(--muted)",
                  alignSelf: "center",
                }}
              >
                {p}
              </span>
              <span
                style={{
                  fontSize: 12,
                  color: v == null ? "var(--muted)" : "var(--ink)",
                }}
              >
                {display}
              </span>
            </div>
          );
        })}
      </div>
    </WidgetCard>
  );
}
